import { useEffect, useState } from "react";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../../firebase";
import "./index.scss";

// Firestore "blogs" documents:
//   title (string), url (string), description (string), cover_image (string),
//   published_at (timestamp), tags (array of strings), reading_time (number)
// Firestore returns them newest first. Documents without published_at are
// left out by orderBy, so an undated document works as a draft.

const formatDate = (date) =>
  date.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let isMounted = true;

    const getBlogs = async () => {
      try {
        const q = query(collection(db, "blogs"), orderBy("published_at", "desc"));
        const querySnapshot = await getDocs(q);
        if (isMounted) {
          setBlogs(querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
        }
      } catch (e) {
        if (isMounted) {
          setError("Something went wrong! Couldn't fetch data at this moment");
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    getBlogs();

    return () => {
      isMounted = false;
    };
  }, []);

  const renderBlogs = () => {
    if (blogs.length === 0) {
      return <p>No articles yet. Check back soon!</p>;
    }

    return (
      <ul className="blog-list">
        {blogs.map((blog) => {
          const date = blog.published_at.toDate();
          return (
            <li key={blog.id}>
              <a className="blog-card" href={blog.url} target="_blank" rel="noreferrer">
                {blog.cover_image && (
                  <img className="blog-cover" src={blog.cover_image} alt="" loading="lazy" />
                )}
                <div className="blog-content">
                  <h2 className="blog-title">
                    {blog.title}
                    <span className="sr-only"> (opens in new tab)</span>
                  </h2>
                  {blog.description && <p className="blog-desc">{blog.description}</p>}
                  <div className="blog-meta">
                    <time dateTime={date.toISOString()}>{formatDate(date)}</time>
                    {blog.reading_time ? (
                      <>
                        <span aria-hidden="true">·</span>
                        <span>{blog.reading_time} min read</span>
                      </>
                    ) : null}
                  </div>
                  {blog.tags?.length > 0 && (
                    <ul className="blog-tags" aria-label="Tags">
                      {blog.tags.map((tag) => (
                        <li key={tag}>#{tag}</li>
                      ))}
                    </ul>
                  )}
                </div>
              </a>
            </li>
          );
        })}
      </ul>
    );
  };

  return (
    <div className="container blog-page">
      <div className="text-zone">
        <h1>Blog</h1>
        <p>
          Articles I've written on Flutter, mobile app development and
          full-stack web development.
        </p>
        {loading ? (
          <div className="loader-container">
            <div className="loader"></div>
          </div>
        ) : error ? (
          <div className="loader-container">
            <div className="error"> {error}</div>
          </div>
        ) : (
          renderBlogs()
        )}
      </div>
    </div>
  );
};

export default Blog;
